import angular from 'angular';
import uiRouter from 'angular-ui-router';
import informationComponent from './information.component';

let informationModule = angular.module('information', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
  .state('dashboard.information', {
    url: '/information',
    component: 'information'
  });
})

.component('information', informationComponent)

.name;

export default informationModule;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/information.js